import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 4 }
const _hoisted_2 = {
  key: 5,
  class: "grid grid-cols-6 gap-6"
}
const _hoisted_3 = { key: 6 }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "flex flex-col space-y-1" }
const _hoisted_6 = { key: 7 }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "flex flex-col space-y-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "ml-2 text-sm font-medium text-neutral-900" }, "Yes/No", -1)
const _hoisted_10 = { key: 8 }
const _hoisted_11 = ["for"]
const _hoisted_12 = { key: 9 }
const _hoisted_13 = ["for"]
const _hoisted_14 = { key: 10 }

import { ref, type PropType, onMounted, watch, computed } from "vue";

import { LinkIcon } from "@heroicons/vue/24/outline";

import TextInput from "@/components/inputs/TextInput.vue";
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import ToggleSwitch from "@/components/inputs/ToggleSwitch.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import CKEditor from "@/components/inputs/CKEditor.vue";
import TimePicker from "@/components/inputs/TimePicker.vue";

import { FormFieldType } from "@/views/enums/FormFieldType";

import { 
    FieldInterface,
} from "@/interfaces/pages/InterventionForm/InterventionFormInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldType',
  props: {
    field: {
        type: Object as PropType<FieldInterface>,
        required: true
    },
    errors: {
        type: Object,
        required: true
    },
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.field.input_type == _unref(FormFieldType).INPUT)
      ? (_openBlock(), _createBlock(TextInput, {
          key: 0,
          type: "text",
          label: __props.field.label,
          placeholder: "Type here",
          name: __props.field.label,
          id: __props.field.label
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true),
    (__props.field.input_type == _unref(FormFieldType).NUMBER)
      ? (_openBlock(), _createBlock(TextInput, {
          key: 1,
          type: "number",
          label: __props.field.label,
          placeholder: "Type here",
          name: __props.field.label,
          id: __props.field.label
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).TEXT)
      ? (_openBlock(), _createBlock(CKEditor, {
          key: 2,
          label: __props.field.label,
          name: __props.field.label,
          id: __props.field.label
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).DROPDOWN)
      ? (_openBlock(), _createBlock(SelectOptions, {
          key: 3,
          options: __props.field.options,
          name: __props.field.label,
          id: __props.field.label,
          label: __props.field.label,
          placeholder: "Select option"
        }, null, 8, ["options", "name", "id", "label"]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).MULTI_SELECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MultiSelect, {
            mode: "tags",
            options: __props.field.options,
            id: __props.field.source_id,
            name: __props.field.label,
            label: __props.field.label,
            placeholder: "Select..",
            required: __props.field.is_required
          }, null, 8, ["options", "id", "name", "label", "required"])
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).DROPDOWN_EXISTING)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(__props.field.is_half_width ? 'col-span-3' : 'col-span-6')
          }, [
            _createVNode(SelectOptions, {
              options: [],
              name: __props.field.label,
              id: __props.field.label,
              label: __props.field.label,
              placeholder: "Select option"
            }, null, 8, ["name", "id", "label"])
          ], 2),
          (__props.field.option_child)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(__props.field.option_child.is_half_width ? 'col-span-3' : 'col-span-6')
              }, [
                _createVNode(SelectOptions, {
                  options: [],
                  name: __props.field.option_child.label,
                  id: __props.field.option_child.label,
                  label: __props.field.option_child.label,
                  placeholder: "Select option"
                }, null, 8, ["name", "id", "label"])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).RADIO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", {
            for: __props.field.label,
            class: "block mb-2 text-xs font-semibold text-neutral-600"
          }, _toDisplayString(__props.field.label), 9, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(RadioGroup, {
              options: __props.field.options,
              name: __props.field.label,
              id: __props.field.label
            }, null, 8, ["options", "name", "id"])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).TOGGLE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", {
            for: __props.field.label,
            class: "block mb-2 text-xs font-semibold text-neutral-600"
          }, _toDisplayString(__props.field.label), 9, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ToggleSwitch, {
              value: _ctx.switchData,
              noPadding: "",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (
                    _ctx.switchData = !_ctx.switchData
                ))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type ===  _unref(FormFieldType).CHECKBOX_OPTION)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("label", {
            for: __props.field.label,
            class: "block mb-2 text-xs font-semibold text-neutral-600"
          }, _toDisplayString(__props.field.label), 9, _hoisted_11),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.options, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-1"
            }, [
              _createVNode(CheckboxInput, {
                name: option.label,
                id: option.label,
                label: option.label
              }, null, 8, ["name", "id", "label"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type ===  _unref(FormFieldType).CHECKBOX_SINGLE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("label", {
            for: __props.field.label,
            class: "block mb-2 text-xs font-semibold text-neutral-600"
          }, _toDisplayString(__props.field.label), 9, _hoisted_13),
          _createVNode(CheckboxInput, {
            label: __props.field.label,
            name: __props.field.label,
            id: __props.field.label
          }, null, 8, ["label", "name", "id"])
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type ===  _unref(FormFieldType).LINK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(TextInput, {
            type: "text",
            label: __props.field.label,
            placeholder: __props.field.label,
            name: __props.field.label,
            id: "attachment",
            required: __props.field.is_required,
            trailingIcon: _unref(LinkIcon),
            customClass: "!pr-10"
          }, null, 8, ["label", "placeholder", "name", "required", "trailingIcon"])
        ]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).DATE_TIME)
      ? (_openBlock(), _createBlock(DatePicker, {
          key: 11,
          label: __props.field.label,
          name: __props.field.label,
          id: __props.field.label,
          enableTimePicker: "",
          timePickerInline: ""
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).DATE)
      ? (_openBlock(), _createBlock(DatePicker, {
          key: 12,
          label: __props.field.label,
          name: __props.field.label,
          id: __props.field.label
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true),
    (__props.field.input_type === _unref(FormFieldType).TIME)
      ? (_openBlock(), _createBlock(TimePicker, {
          key: 13,
          label: __props.field.label,
          name: __props.field.label,
          id: __props.field.label,
          timePicker: "",
          enableTimePicker: ""
        }, null, 8, ["label", "name", "id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})